import type { ComponentProps, ReactNode } from 'react'
import { useMemo } from 'react'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'
import { useIntl } from 'react-intl'

type BodyTextBlockProps = ComponentProps<typeof BodyTextBlock>

interface Props {
  inclusion: App.OfferInclusion
  isHighlighted?: boolean
  /**
   * @default medium
   */
  size?: BodyTextBlockProps['variant']
  format?: BodyTextBlockProps['format']
  colour?: BodyTextBlockProps['colour']
  lineClamp?: BodyTextBlockProps['lineClamp']
  /**
   * @default default
   */
  type?: 'default' | 'lux-plus'
  showMinStayDescription?: boolean
  endIcon?: ReactNode
}

function OfferInclusionItem({
  inclusion,
  isHighlighted,
  size = 'medium',
  format,
  colour,
  lineClamp,
  type,
  showMinStayDescription,
  endIcon,
}: Props) {
  const intl = useIntl()
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion])
  const highlighted = isHighlighted ?? inclusion.isHighlighted
  const iconColour: SvgIconProps['colour'] = type === 'lux-plus' ? 'lux-plus' : highlighted ? 'highlight-secondary' : undefined
  const minStayDescription = showMinStayDescription ? getInclusionMinStayText(inclusion, intl) : undefined

  return <BodyTextBlock
    variant={size}
    format={format}
    colour={colour}
    lineClamp={lineClamp}
    weight={highlighted ? 'bold' : 'normal'}
    startIcon={<Icon colour={iconColour} data-symbol={inclusion.symbol} />}
    endIcon={endIcon}
  >
    {inclusion.description} {minStayDescription}
  </BodyTextBlock>
}

export default OfferInclusionItem
